import { render, staticRenderFns } from "./CommitteesCreate.vue?vue&type=template&id=eda3f026"
import script from "./CommitteesCreate.vue?vue&type=script&lang=js"
export * from "./CommitteesCreate.vue?vue&type=script&lang=js"
import style0 from "./CommitteesCreate.vue?vue&type=style&index=0&id=eda3f026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports